import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { fmtMoney, fmtDate } from "../lib/api";

export default function ConfirmMarkPaidDialog({ open, onOpenChange, payment, onConfirm, busy }) {
  if (!payment) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!rounded-none bg-white border border-stone max-w-md text-graphite p-0">
        <DialogHeader className="px-6 py-4 border-b border-stone">
          <DialogTitle className="text-base font-mono uppercase tracking-widest text-paars-dark">
            // RECORD AS PAID
          </DialogTitle>
        </DialogHeader>
        <div className="p-6 space-y-4">
          <div className="text-sm text-graphite/60">Record this projected coupon payment as received?</div>
          <div className="border border-stone bg-champagne p-4 space-y-2 font-mono text-sm">
            <Row k="Ticker" v={<span className="text-paars-dark">{payment.ticker}</span>} />
            <Row k="Date" v={fmtDate(payment.date)} />
            <Row k="Amount" v={<span className="text-groen-dark">{fmtMoney(payment.amount)}</span>} />
          </div>
          <div className="text-[11px] text-graphite/45">
            This will be saved as a dividend (source: projected) and removed from the upcoming list.
          </div>
        </div>
        <DialogFooter className="!flex !justify-end gap-2 p-6 pt-0">
          <button onClick={() => onOpenChange(false)} className="px-5 py-2.5 border border-paars-dark/30 text-graphite/80 text-sm hover:bg-stone/50">
            Cancel
          </button>
          <button
            data-testid="confirm-mark-paid-btn"
            onClick={onConfirm}
            disabled={busy}
            className="px-5 py-2.5 bg-paars text-graphite font-semibold text-sm hover:bg-paars-light disabled:opacity-50"
          >
            {busy ? "RECORDING..." : "CONFIRM"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-[10px] tracking-[0.25em] uppercase text-graphite/55">{k}</span>
      <span>{v}</span>
    </div>
  );
}
